import { UIHeading2 } from '@cian/ui-kit';

import { type ReactNode } from 'react';

import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors';

import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';

import { PriceLayout } from '../components/PriceLayout';

import { FavoritesActionButtonContainer } from './FavoritesActionButton';

export function PriceContainer(): ReactNode {
  const {
    terms: { price },
  } = useCardOfferDataContext();

  const isNarrow = useListingLayoutIsNarrowSelector();

  return (
    <PriceLayout>
      <UIHeading2>
        <span data-testid="card.price">{price}</span>
      </UIHeading2>
      {isNarrow && <FavoritesActionButtonContainer />}
    </PriceLayout>
  );
}
